import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventScroll]'
})
export class PreventScrollDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    if ((<HTMLElement>event.target).nodeName === 'INPUT' && (<HTMLInputElement>event.target).type === 'number') {
      event.preventDefault();
    }
  }
}
